import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as THREE from 'three';

export default function PageNotFound() {
  const ref = useRef();

  useEffect(() => {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000,
    );
    const renderer = new THREE.WebGLRenderer();
    renderer.setSize(window.innerWidth, window.innerHeight);
    ref.current.appendChild(renderer.domElement);
    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const material = new THREE.MeshBasicMaterial({ color: '#04798a' });
    const cube = new THREE.Mesh(geometry, material);
    scene.add(cube);
    camera.position.z = 6;
    const animate = function () {
      requestAnimationFrame(animate);
      cube.rotation.x += 0.01;
      cube.rotation.y += 0.01;
      renderer.render(scene, camera);
    };
    animate();
  }, []);

  return (
    <div style={{ background: 'black' }}>
      <div
        id="404"
        style={{
          position: 'absolute',
          top: '25rem',
          width: '100%',
          left: '6rem',
          textAlign: 'left',
          zIndex: '100',
          display: 'block',
          color: '#56767b',
          fontWeight: '600',
          fontSize: '2rem',
        }}
      >
      404 <span style={{color: 'rgba(204, 214, 216, 0.9)'}}>Page not found</span>
      </div>
      <Link to="/">
        <div ref={ref} style={{ cursor: 'pointer' }} />{' '}
      </Link>
    </div>
  );
}
